<div class="filtros-trigger-wrapper" *ngIf="temFiltros$ | async" style="font-family: 'Nunito', sans-serif;">
  <button
    type="button"
    class="filtros-btn"
    [class.active]="isOpen"
    (click)="toggle()"
  >
    <mat-icon class="filtros-btn-icon">filter_alt</mat-icon>
    <span>{{ 'FILTER.TITLE' | translate }}</span>
    <span class="filtros-btn-chevron-wrapper">
      <mat-icon class="filtros-btn-chevron">{{ isOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
      <span class="filtros-badge" *ngIf="(appliedCount$ | async)">{{ appliedCount$ | async }}</span>
    </span>
  </button>

  <!-- Mantido sempre no DOM (mostrado/ocultado via CSS) para não perder o estado dos campos ao fechar -->
  <div class="filtros-panel" [class.open]="isOpen" (click)="$event.stopPropagation()">
    <div class="filtros-panel-body">
      <ng-container *ngIf="itemNome$ | async as item">
        <app-toolbar-filtro-item
          [nome]="item[0]"
          [filtroNome]="item[1]"
          [modoHorario]="false"
          (objChange)="objHandler($event)"
        ></app-toolbar-filtro-item>
      </ng-container>

      <div class="status-field" *ngIf="mostrarStatus$ | async">
        <label class="status-field-label">Status</label>
        <div class="status-select-wrapper">
          <mat-select
            [(value)]="draftStatus"
            (selectionChange)="applyStatus($event.value)"
            class="status-select-panel"
            [placeholder]="'Status'"
          >
            <mat-option *ngFor="let statusOption of status" [value]="statusOption" style="font-family: 'Nunito', sans-serif;">
              {{ statusOption }}
            </mat-option>
          </mat-select>
          <button
            matTooltip="{{ 'FILTER.REMOVE_FILTER' | translate }}"
            mat-icon-button
            class="remove-filter-btn"
            *ngIf="draftStatus && draftStatus !== 'Todos'"
            (click)="clearStatusFilter(); $event.stopPropagation()"
            type="button"
          >
            <mat-icon class="remove-icon">close</mat-icon>
          </button>
        </div>
      </div>

      <div class="row-inicio-fim" *ngIf="(itemInicio$ | async) || (itemFim$ | async)">
        <ng-container *ngIf="itemInicio$ | async as item">
          <app-toolbar-filtro-item
            [nome]="item[0]"
            [filtroNome]="item[1]"
            [modoHorario]="true"
            (objChange)="objHandler($event)"
          ></app-toolbar-filtro-item>
        </ng-container>

        <ng-container *ngIf="itemFim$ | async as item">
          <app-toolbar-filtro-item
            [nome]="item[0]"
            [filtroNome]="item[1]"
            [modoHorario]="true"
            (objChange)="objHandler($event)"
          ></app-toolbar-filtro-item>
        </ng-container>
      </div>
    </div>

    <div class="filtros-panel-actions">
      <button type="button" class="btn-limpar" (click)="limpar()">Limpar</button>
    </div>
  </div>
</div>
